<template>
  <v-card dark max-width="700px">
    <v-card-title>
      <v-alert text width="100%" color="deep-orange" icon="mdi-alert-circle-outline" border="left">
        Escolha uma senha forte e não a use novamente em outras contas.
      </v-alert>
    </v-card-title>

    <v-card-text>
      <v-form ref="formChangePassword" lazy-validation>
        <v-text-field
          v-model="old_password"
          type="password"
          color="yellow"
          autocomplete="off"
          label="Senha atual"
          :rules="[(v) => !!v || 'O campo é obrigatório']"
          autofocus></v-text-field>

        <v-text-field
          v-model="password"
          name="new-password"
          label="Senha"
          :type="showPass ? 'text' : 'password'"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPass = !showPass"
          :color="colorInput"
          :rules="rules"
          :loading="!!password"
          :error-messages="
            error4017 ? 'Sua nova senha deve ser diferente das utilizadas anteriormente' : ''
          "
          autocomplete="off"
          dark>
          <template v-slot:progress>
            <v-progress-linear
              v-if="password"
              :value="progress"
              :color="colorBar"
              absolute
              height="5" />
          </template>
        </v-text-field>

        <v-text-field
          v-model="confirmPassword"
          name="confirm-password"
          label="Confirmação da senha"
          :type="showConfirmPass ? 'text' : 'password'"
          :append-icon="showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showConfirmPass = !showConfirmPass"
          :rules="[(v) => v === password || 'Senhas devem ser iguais']"
          autocomplete="off"
          dark
          color="green" />

        <v-row class="mt-2">
          <v-col v-for="(rule, index) in checklist" :key="index" cols="12" md="6" class="pt-1 pb-0">
            {{ rule.label }}
            <v-icon class="ml-2" :color="rule.valid ? '#69F0AE' : 'red'">
              {{ rule.valid ? "mdi-check" : "mdi-close" }}
            </v-icon>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-btn text @click="cancel">Cancelar</v-btn>
      <v-spacer />
      <v-btn :disabled="!canSubmit" color="yellow" :loading="loading" dark text @click="submit"
        >Enviar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { isPasswordValid } from "@/utils/password";
import { mapGetters } from "vuex";

export default {
  name: "ChangePasswordForm",
  data() {
    return {
      password: "",
      old_password: "",
      confirmPassword: "",
      showPass: false,
      showConfirmPass: false,
      error4017: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("meState", {
      me: "me",
    }),

    canSubmit() {
      const matchingPasswords = this.password === this.confirmPassword;
      return this.progress === 100 && matchingPasswords && this.old_password && this.password;
    },
    checklist() {
      return [
        { label: "Não pode estar vazio", valid: this.password.length > 0 },
        { label: "Precisa ter uma letra maiúscula", valid: /[A-Z]/.test(this.password) },
        { label: "Precisa ter uma letra minúscula", valid: /[a-z]/.test(this.password) },
        { label: "Precisa ter um número", valid: /[0-9]/.test(this.password) },
        {
          label: "Precisa ter um caractere especial",
          valid: /[@!#$%^&*()/\\]/.test(this.password),
        },
        { label: "Precisa ter no mínimo 14 caracteres", valid: this.password.length >= 14 },
        {
          label:
            "Não pode conter palavras proibídas (seu nome, quiteja, sequência de números e letras, etc.)",
          valid: isPasswordValid(this.password, this.me?.name),
        },
      ];
    },
    progress() {
      const validCount = this.checklist.filter((r) => r.valid).length;
      return (validCount / this.checklist.length) * 100;
    },
    colorBar() {
      if (this.progress < 40) return "error";
      if (this.progress < 100) return "warning";
      return "success";
    },
    colorInput() {
      return this.progress === 0 ? "yellow" : this.colorBar;
    },
    rules() {
      return [
        (v) => !!v || "Campo obrigatório",
        (v) => /[A-Z]/.test(v) || "Deve conter letra maiúscula",
        (v) => /[a-z]/.test(v) || "Deve conter letra minúscula",
        (v) => /[0-9]/.test(v) || "Deve conter número",
        (v) => /[@!#$%^&*()/\\]/.test(v) || "Deve conter caractere especial",
        (v) => v.length >= 14 || "Mínimo de 14 caracteres",
      ];
    },
  },
  methods: {
    cancel() {
      this.password = "";
      this.old_password = "";
      this.$emit("cancel");
    },
    submit() {
      if (!this.$refs.formChangePassword.validate()) return;

      this.$emit("submit", {
        old: this.old_password,
        new: this.password,
      });
    },
  },
};
</script>
